import {Box, Button, Container, CssBaseline, IconButton, InputAdornment} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import {Link, useNavigate} from "react-router-dom";
import TextField from "@mui/material/TextField";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {LoginContext} from "../../../../../ContextServer/LoginConetxt";
import AdminDeclareList from "../AdminDeclareList";


function Copyright(props) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            {...props}
        >
            {"Copyright © "}
            <Link color="inherit" href="#">
                나주시
            </Link>
            {new Date().getFullYear()}
        </Typography>
    );
}

function AdminLogins() {
    const {LoginSubmit, value, setValue, suc} = useContext(LoginContext);

    const navigate = useNavigate();

    const [values, setValues] = useState({
        showPass: false
    })

    const togglePasswordHide = () => {
        setValues({
            ...values,
            showPass: !values.showPass
        });
    };

    useEffect(()=>{
        if(suc === true){
            navigate('/odor/declarelist/admin')
        }
    },[suc]);


    return (
        <div>
            <div className="declarelist-container">
                <div className="declarelist-box">
                    <div className="declarelist-contents">

                        <div className="declareTitle">
                            <h2>관리자 로그인</h2>
                        </div>

                        <Container
                            component="main"
                            maxWidth="xs"
                            style={{
                                backgroundColor: "#ffffff",
                                border: "1px solid white",
                                margin: "2vh auto",
                            }}
                        >
                            <CssBaseline/>
                            <Box
                                sx={{
                                    height: "40vh",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                                className="login-form"
                            >

                                <Box component="form" sx={{marginTop: 10}} onSubmit={LoginSubmit}>
                                    <TextField
                                        id="outlined-basic"
                                        label="ID"
                                        variant="outlined"
                                        name="user_id"
                                        onChange={(e) => setValue({...value, user_id: e.target.value})}
                                        fullWidth
                                    />
                                    <TextField
                                        margin="normal"
                                        id="outlined-basic"
                                        type={values.showPass ? "text" : "password"}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password"
                                                        edge="end"
                                                        onClick={togglePasswordHide}
                                                    >
                                                        {values.showPass ? (
                                                            <VisibilityIcon/>
                                                        ) : (
                                                            <VisibilityOffIcon/>
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        label="password"
                                        variant="outlined"
                                        name="user_pwd"
                                        onChange={(e) => setValue({...value, user_pwd: e.target.value})}
                                        fullWidth
                                    />

                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="outlined"
                                        sx={{mt: 3, mb: 2}}
                                    >
                                        LOGIN
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            navigate(-1);
                                        }}
                                        style={{marginTop: "2vh"}}
                                    >
                                        관리자가 아닐 경우 이용 불가합니다.
                                    </Button>
                                </Box>
                            </Box>
                            <Copyright sx={{mt: 8, mb: 4}}/>
                        </Container>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default AdminLogins;